module.exports = __webpack_public_path__ + "static/img/test5.7d4f554.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/test/test5.jpg
// module id = vO5I
// module chunks = 2